import { Line as LineUtil } from '@antv/g-math';
export default function inLine(x1, y1, x2, y2, lineWidth, x, y) {
    var minX = Math.min(x1, x2);
    var maxX = Math.max(x1, x2);
    var minY = Math.min(y1, y2);
    var maxY = Math.max(y1, y2);
    var halfWidth = lineWidth / 2;
    // å ä¸ºç®åçæ¹æ¡æ¯è®¡ç®ç¹å°ç´çº¿çè·ç¦»ï¼èæå¯è½ä¼å¨å»¶é¿çº¿ä¸ï¼æä»¥è¦åå¤æ­æ¯å¦å¨åå´çå
    // è¿ç§æ¹æ¡ä¼å¨æ°´å¹³æèç«ç´çæåµä¸è½½çº¿çå»¶é¿çº¿ä¸æå lineWidth çè¯¯å·®
    if (!(x >= minX - halfWidth && x <= maxX + halfWidth && y >= minY - halfWidth && y <= maxY + halfWidth)) {
        return false;
    }
    // å ä¸ºå·²ç»è®¡ç®äºåå´çï¼æä»¥ä»éè¦è®¡ç®å°ç´çº¿çè·ç¦»å³å¯ï¼å¯ä»¥æ¾èæåæ§è½
    return LineUtil.pointToLine(x1, y1, x2, y2, x, y) <= lineWidth / 2;
}
//# sourceMappingURL=line.js.map